import {useState, useCallback} from 'react';

export const useFileUploadModal = () => {
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false);
  const [selectedTierInfo, setSelectedTierInfo] = useState({
    id: null,
    name: ''
  });
  const [formData, setFormData] = useState({});

  const handleModalOpen = useCallback((tierId, tierName) => {
    setSelectedTierInfo({
      id: tierId,
      name: tierName
    });
    setIsFileUploadModalOpen(true);
  }, []);

  return {
    isFileUploadModalOpen,
    setIsFileUploadModalOpen,
    selectedTierInfo,
    handleModalOpen,
    formData,
    setFormData
  };
};
